export default __webpack_public_path__ + "static/media/ic_special_offers.c3d824fd.svg";